import React from 'react'
import { IconBaseProps } from 'react-icons'

const DEFAULT_SIZE = '1em'

export default function CopIcon({ size }: IconBaseProps) {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 256.000000 256.000000"
      id="svg20"
      width={size ?? DEFAULT_SIZE}
      height={size ?? DEFAULT_SIZE}
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M1265 2497 c-60 -20 -97 -41 -255 -147 -270 -180 -393 -240 -600
-291 -162 -40 -188 -74 -135 -178 27 -54 56 -86 163 -179 78 -68 95 -94 106
-157 4 -22 16 -55 27 -73 15 -27 19 -53 19 -133 0 -97 0 -99 -24 -99 -31 0
-72 -40 -96 -92 -44 -97 -12 -228 71 -288 24 -17 52 -33 64 -36 16 -4 30 -27
55 -87 144 -358 327 -587 527 -659 82 -30 207 -30 288 0 78 29 184 102 241
166 98 111 224 328 289 499 25 65 33 76 62 87 87 31 145 119 144 220 0 96 -41
169 -107 190 l-34 12 0 95 c0 82 3 99 22 126 13 18 25 54 29 89 8 70 36 111
117 170 120 87 172 153 172 221 0 53 -31 74 -163 106 -144 36 -268 94 -417
196 -262 180 -300 204 -352 223 -74 28 -162 35 -213 19z m205 -124 c36 -17
139 -83 230 -147 222 -156 407 -244 568 -271 23 -4 42 -11 42 -16 0 -17 -62
-79 -129 -128 -70 -52 -109 -99 -135 -163 l-16 -36 -52 28 c-68 36 -218 84
-333 107 -140 27 -513 24 -652 -5 -118 -26 -260 -73 -320 -108 l-41 -24 -31
55 c-21 37 -60 79 -121 131 -76 65 -130 126 -130 147 0 2 17 8 38 11 177 31
380 123 612 277 85 56 187 120 225 141 62 34 76 38 125 35 35 -2 79 -14 120
-34z m201 -732 c137 -30 329 -107 329 -131 0 -12 -74 -76 -122 -106 -59 -38
-168 -78 -268 -100 -68 -15 -126 -19 -285 -19 -236 1 -331 19 -480 90 -86 41
-175 109 -175 134 0 37 214 116 395 146 135 22 478 14 606 -14z m-852 -361
c282 -140 813 -126 1084 30 l67 38 0 -99 0 -99 44 6 c58 8 83 -7 97 -58 26
-100 -17 -169 -121 -192 -21 -4 -31 -21 -59 -93 -44 -112 -138 -299 -192 -383
-62 -95 -182 -211 -254 -246 -53 -26 -71 -29 -155 -29 -86 0 -101 3 -155 30
-158 79 -309 295 -444 633 -28 69 -38 83 -60 88 -63 13 -92 34 -113 80 -42 96
1 179 89 172 l43 -3 0 98 0 99 33 -20 c17 -12 61 -35 96 -52z"
        />
        <path
          d="M1255 2193 c-76 -40 -83 -76 -32 -175 23 -46 43 -68 69 -83 35 -18
38 -19 72 -3 44 21 81 76 99 148 13 50 13 57 -2 74 -46 52 -146 71 -206 39z"
        />
        <path
          d="M841 1116 c-71 -40 -67 -160 8 -247 68 -80 165 -100 258 -54 67 34
123 115 123 179 0 29 21 36 107 36 72 0 93 -6 93 -29 0 -70 63 -160 135 -192
139 -64 305 50 305 208 0 49 -16 80 -50 98 -27 14 -56 16 -183 11 -84 -3 -165
-5 -182 -4 -45 1 -205 2 -245 0 -19 0 -105 1 -190 3 -118 4 -161 2 -179 -9z"
        />
      </g>
    </svg>
  )
}
